import { strFromU8, unzipSync } from 'fflate';

const MAX_ARCHIVE_SIZE = 1024 * 1024;
const MAX_ANIMATION_SIZE = 4 * 1024 * 1024;
const ANIMATION_FILE_PATTERN = /(^|\/)animation\.json$/i;

export const isLottieStickerAttachment = attachment =>
  attachment?.extension?.toLowerCase() === 'was';

export const extractLottieAnimation = archiveData => {
  const bytes =
    archiveData instanceof Uint8Array
      ? archiveData
      : new Uint8Array(archiveData);

  if (bytes.byteLength > MAX_ARCHIVE_SIZE) {
    throw new Error('Lottie sticker archive is too large');
  }

  const files = unzipSync(bytes, {
    filter: file =>
      ANIMATION_FILE_PATTERN.test(file.name) &&
      file.originalSize <= MAX_ANIMATION_SIZE,
  });
  const animationFile = Object.entries(files).find(([name]) =>
    ANIMATION_FILE_PATTERN.test(name)
  )?.[1];

  if (!animationFile) {
    throw new Error('Lottie sticker animation is missing');
  }

  return JSON.parse(strFromU8(animationFile));
};
